import { render, staticRenderFns } from "./Marquee.vue?vue&type=template&id=7fd879fd&scoped=true&"
import script from "./Marquee.vue?vue&type=script&lang=ts&"
export * from "./Marquee.vue?vue&type=script&lang=ts&"
import style0 from "./Marquee.vue?vue&type=style&index=0&id=7fd879fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd879fd",
  null
  
)

export default component.exports